module.exports = __webpack_public_path__ + "317e304cd28af582b6f0a5002a279a62.svg";